import {ValidEmail} from 'Core/models/Email';
import {NonEmptyString} from 'Core/models/EmptyString';
import {ValidPhoneNumber} from 'Core/models/PhoneNumber';
import {all, takeLatest} from 'redux-saga/effects';
import {getValidationSaga} from 'Shared/utilities/sagaApiGenerators';
import userApi from 'Users/api/userApi';
import {setEmail, setPhone, setUsername, VipUserActionType} from 'Users/ducks/vipUser';

export function* validateEmailSaga() {
  yield takeLatest(
    VipUserActionType.VALIDATE_EMAIL,
    getValidationSaga(ValidEmail.create, setEmail, userApi.validateEmail)
  );
}

export function* validatePhoneSaga() {
  yield takeLatest(
    VipUserActionType.VALIDATE_PHONE,
    getValidationSaga(ValidPhoneNumber.create, setPhone, userApi.validatePhoneNumber)
  );
}

export function* validateUsernameSaga() {
  yield takeLatest(
    VipUserActionType.VALIDATE_USERNAME,
    getValidationSaga(NonEmptyString.create, setUsername, userApi.validateAllstateUsername)
  );
}

export default function*() {
  yield all([validateUsernameSaga(), validateEmailSaga(), validatePhoneSaga()]);
}
